import { render } from "./RightSidebarLayout.vue?vue&type=template&id=047d0806"
import script from "./RightSidebarLayout.vue?vue&type=script&lang=js"
export * from "./RightSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/classic/RightSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "047d0806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('047d0806', __exports__)) {
    api.reload('047d0806', __exports__)
  }
  
  module.hot.accept("./RightSidebarLayout.vue?vue&type=template&id=047d0806", () => {
    api.rerender('047d0806', render)
  })

}


export default __exports__